export const messages = {
    "wr-dashboard.search.input.hint": "Søg",
    "wr-dashboard.search.label.breadcrumb": "Søgeresultater",
    "wr-dashboard.search.message.empty": "Ingen elementer matcher dine søgning",
    "wr-dashboard.side-bar.selected.title:plural": "{count} elementer er valgt | {count} element er valgt | {count} elementer er valgt",
    "wr-dashboard.side-bar.backup-type.disk": "Disk",
    "wr-dashboard.side-bar.backup-type.file": "Fil",
    "wr-dashboard.side-bar.backup-type.notarized": "Notarbekræftede filer og mapper",
    "wr-dashboard.side-bar.backup-type.exchange": "Program - Microsoft Exchange",
    "wr-dashboard.side-bar.backup-type.sql": "Program - Microsoft SQL",
    "wr-dashboard.side-bar.backup-type.sys-state": "Program - Systemtilstand",
    "wr-dashboard.side-bar.backup-type.application": "Applikation",
    "wr-dashboard.backups-table.column.name": "Navn",
    "wr-dashboard.backups-table.column.size": "Størrelse",
    "wr-dashboard.backups-table.column.version": "Sidste version",
    "wr-dashboard.backups-table.action.delete": "Slet",
    "wr-dashboard.backups-table.message.no-backups": "Der er endnu ingen sikkerhedskopier i clouden",
    "wr-dashboard.backups-sidebar.label.size": "Størrelse",
    "wr-dashboard.backups-sidebar.label.type": "Type",
    "wr-dashboard.backups-sidebar.label.version": "Sidste version",
    "wr-dashboard.backups-sidebar.label.created": "Oprettet",
    "wr-dashboard.backups-sidebar.label.machine": "Maskine",
    "wr-dashboard.backups-sidebar.label.owner": "Ejer",
    "wr-dashboard.content-table.column.name": "Navn",
    "wr-dashboard.content-table.column.versions": "Versioner",
    "wr-dashboard.content-table.column.volumes": "Diskenheder",
    "wr-dashboard.content-table.column.path": "Sti",
    "wr-dashboard.content-table.column.size": "Størrelse",
    "wr-dashboard.content-table.column.version": "Sidste version",
    "wr-dashboard.content-table.action.notary-verify": "Bekræft",
    "wr-dashboard.content-table.action.notary-get-crt": "Hent certifikat",
    "wr-dashboard.content-table.action.asign": "Send til signering",
    "wr-dashboard.content-table.action.versions": "Versioner",
    "wr-dashboard.content-table.action.restore": "Download",
    "wr-dashboard.content-table.label.size": "Størrelse",
    "wr-dashboard.content-table.label.created": "Oprettet",
    "wr-dashboard.content-table.label.modified": "Ændret",
    "wr-dashboard.content-table.message.empty-folder": "Denne mappe er tom",
    "wr-dashboard.password-dialog-box.title.backup": "Krypteret sikkerhedskopi",
    "wr-dashboard.password-dialog-box.title.archive": "Krypteret arkiv",
    "wr-dashboard.password-dialog-box.message.backup": "Angiv adgangskoden for at få adgang til sikkerhedskopien {displayName}",
    "wr-dashboard.password-dialog-box.message.archive": "Angiv adgangskoden for at få adgang til arkivet {displayName}",
    "wr-dashboard.password-dialog-box.hint.password": "Adgangskode",
    "wr-dashboard.password-dialog-box.message.invalid-password": "Adgangskoden er forkert",
    "wr-dashboard.form.button.open": "Åbn",
    "wr-dashboard.form.button.close": "Luk",
    "wr-dashboard.form.button.cancel": "Annuller",
    "wr-dashboard.form.button.continue": "Fortsæt",
    "wr-dashboard.form.button.proceed": "Fortsæt",
    "wr-dashboard.form.button.delete": "Slet",
    "wr-dashboard.form.button.done": "Udført",
    "wr-dashboard.form.button.retry": "Prøv igen",
    "wr-dashboard.notary.verify.view.status.downloading": "Downloader...",
    "wr-dashboard.notary.verify.view.status.validating": "Validerer...",
    "wr-dashboard.notary.verify.view.status.pending": "Afventer certifikat...",
    "wr-dashboard.notary.verify.view.status.fail": "Certifikaterne stemmer ikke overens...",
    "wr-dashboard.notary.verify.view.button.get-crt": "Hent certifikat",
    "wr-dashboard.notary.verify.view.file-info.name": "NAVN",
    "wr-dashboard.notary.verify.view.file-info.signed-by": "SIGNERET AF",
    "wr-dashboard.notary.verify.view.file-info.date-backed-up": "DATO SIKKERHEDSKOPIERET",
    "wr-dashboard.notary.verify.view.file-info.date-notarized": "DATO NOTARBEKRÆFTET",
    "wr-dashboard.notary.verify.view.button.cancel": "Annuller",
    "wr-dashboard.notary.verify.view.button.done": "Udført",
    "wr-dashboard.notary.warning.unsupported.browser.version": "Browserversionen understøttes ikke",
    "wr-dashboard.versions-dialog-box.title": "Versioner af {fileName}",
    "wr-dashboard.asign-dialog-box.title": "Send til signering",
    "wr-dashboard.asign-dialog-box.message": "Filversionen er delt, men ingen kan se filen uden linket til den. Fortsæt til ASign for at tilføje underskrivere og dele linket.",
    "wr-dashboard.asign-dialog-box.button.show-signed-file-details": "Vis fildetaljer",
    "wr-dashboard.page-not-found.title": "Siden blev ikke fundet",
    "wr-dashboard.page-not-found.message.main": "Den side, du søgte efter, blev ikke fundet.",
    "wr-dashboard.page-not-found.message.description": "Linket kan være forældet, eller du kan have indtastet adressen forkert.",
    "wr-dashboard.page-not-found.message.error": "Fejlkode: 404",
    "wr-dashboard.server-error.title": "Serveren er ikke tilgængelig",
    "wr-dashboard.server-error.message": "Serveren er ikke tilgængelig i øjeblikket. Prøv igen senere.",
    "wr-dashboard.server-error.message.error": "Fejlkode: 500",
    "wr-dashboard.account-menu.action.sign-out": "Log ud",
    "wr-dashboard.breadcrumb.item.machines": "Maskiner",
    "wr-dashboard.breadcrumb.item.failed-backups": "Mislykkede sikkerhedskopieringer",
    "wr-dashboard.machines-table.column.name": "Navn",
    "wr-dashboard.machines-table.column.size": "Størrelse",
    "wr-dashboard.machines-table.message.no-machines": "Der er endnu ingen maskiner i cloudmiljøet",
    "wr-dashboard.incomplete-backups.message.status:plural": "Du har {count} mislykkede eller ufuldstændige sikkerhedskopier, der optager {size} lagerplads | Du har {count} mislykket eller ufuldstændig sikkerhedskopi, der optager {size} lagerplads | Du har {count} mislykkede eller ufuldstændige sikkerhedskopier, der optager {size} lagerplads",
    "wr-dashboard.incomplete-backups.button.view": "Få vist sikkerhedskopier",
    "wr-dashboard.incomplete-backups.button.delete": "Slet sikkerhedskopier",
    "wr-dashboard.machines-table.message.space-used:plural": "Forbrug af sikkerhedskopier i alt {size}",
    "wr-dashboard.delete-archive-dialog-box.title": "Slet arkiver",
    "wr-dashboard.delete-incomplete-archive-dialog-box.title": "Slet ufuldstændige arkiver",
    "wr-dashboard.delete-all-incomplete-archives-dialog-box.title": "Slet alle ufuldstændige arkiver",
    "wr-dashboard.delete-archive.message": "Er du sikker på, at du vil slette de valgte arkiver permanent fra alle placeringer? Alle data slettes og kan ikke gendannes.",
    "wr-dashboard.certificate-pending-dialog-box.title": "Certifikatet afventer",
    "wr-dashboard.certificate-pending-dialog-box.message": "Prøv venligst igen om nogle minutter.",
    "wr-dashboard.form.button.ok": "OK"
};
